import { convertBytesToMb } from './convertBytesToMb';

/**
 * Formats upload progress as "{uploaded} / {total} MB" (whole MB, thousands separators),
 * mirroring the "{uploaded} / {all} files" counter used for other upload types — same
 * shape, counts up toward the total. Uses MiB (via convertBytesToMb) for consistency.
 */
export const formatMegabytesProgress = (uploadedBytes: number, totalBytes: number): string => {
  const total = Math.round(convertBytesToMb(Math.max(totalBytes, 0)));
  // Clamp uploaded to total so a rounding/progress overshoot never shows more than the total.
  const uploaded = Math.round(convertBytesToMb(Math.min(Math.max(uploadedBytes, 0), Math.max(totalBytes, 0))));

  return `${uploaded.toLocaleString('en-US')} / ${total.toLocaleString('en-US')} MB`;
};
